/* istanbul ignore file */

/**
 *
 * Search Data Context Provider
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * Gets json datas for search from different services/usestore
 * Provides Json Data Used to filter and handle search logic from UI
 * provider to set required json datas/files readily available in props while search comp is rendered
 *
 */
import React, { useEffect, useState, useContext } from 'react';
import { SearchDataContext } from '../../../../helpers/SVBContextManager';
import { useStore } from '../../../../core/useStore';
import useFilteredCatalogLatestVersion from '../../../../helpers/utilityCustomHooks/useFilteredCatalogLatestVersion';
import { getFileContent } from '../../../../helpers/utilityFunctions';

const SearchDataProvider = ({ children }) => {
  //states to hold data for apis, faqs, solutions and resources for search
  const [apisDataFromJson, setApis] = useState([]);
  const [faqsDataFromJson, setFaqs] = useState([]);
  const [solutionsDataFromJson, setSolutions] = useState([]);
  const [resourcessDataFromJson, setResources] = useState([]);
  // data from usestore for faqs, apis(latest versions only), contents(solutions and resources)
  const faqsDataFromUseStore = useStore((state) => state.faqsItems);
  const apisDataFromUseStore = useFilteredCatalogLatestVersion();
  const searchMockDataFromUseStore = useStore((state) => state.searchResourcesMock);
  const [shouldGetMockContent, setshouldGetMockContent] = useState(false); //control for whether to trigger api for getting content mock file from svc
  //hook to get content from svc
  const getSearchMockContents = getFileContent(
    `${process.env.REACT_APP_CONTENT_SERVER}/portal-content?resourcePath=pages/search&resourceName=resources-searchmock.json`,
    null,
    shouldGetMockContent,
  );
  //returns true if there is any data in useStore for mock json for contents(solutions, resources, etc.)
  const mockSearchstoreHasValue = (data) =>
    Object.values(data).some((value) => Array.isArray(value) && value.length > 0);

  useEffect(() => {
    setApis(apisDataFromUseStore);
    setFaqs(faqsDataFromUseStore);
    if (mockSearchstoreHasValue(searchMockDataFromUseStore)) {
      // checks and uses use store data and sets state from the available data
      setSolutions(searchMockDataFromUseStore?.solutions || []);
      setResources(searchMockDataFromUseStore?.resources || []);
    } else {
      //trigger api hook to get mock file for content from svc if data not available on store
      setshouldGetMockContent(true);
    }
  }, []);

  //setting the data for content mock, once it is fetched from the svc successfully
  useEffect(() => {
    if (getSearchMockContents?.type === 'success') {
      useStore.setState({ searchResourcesMock: getSearchMockContents?.response });
      setshouldGetMockContent(false);
      setSolutions(getSearchMockContents?.response?.solutions);
      setResources(getSearchMockContents?.response?.resources);
    }
  }, [getSearchMockContents]);

  return (
    <SearchDataContext.Provider
      value={{ apisDataFromJson, faqsDataFromJson, solutionsDataFromJson, resourcessDataFromJson }}
    >
      {children}
    </SearchDataContext.Provider>
  );
};
export const useSearchJsonData = () => useContext(SearchDataContext);
export default SearchDataProvider;
